import financ1 from "../assets/images/financ1.png";
import financ2 from "../assets/images/financ2.png";
import financ3 from "../assets/images/financ3.png";
import financ4 from "../assets/images/financ4.png";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import React from "react";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import Financialtabs from "../components/adminFinancial/Financialtabs";
// import "../components/adminFinancial/adminFinancial.scss";

import "../components/adminFinancial/adminFinancial.scss";
import sendRequest from "hooks/useAxios";
import sendRequest2 from "hooks/useAxios2";
import Card from "../components/Card/Card";
import UpdateOrderModal from "common/order/UpdateOrderModal";
import UpdateRepairModal from "common/order/UpdateRepairModal";
import ComplatePriceModalAdmin from "common/order/ComplatePriceModalAdmin";
export default function AdminFinancial() {
  const [cardItem, setCardItem] = useState({
    allOrders: "",
    totalAmount: "",
    paidAmount: "",
    notPaidAmount: "",
  });
  const [transactionsList, setTransactionsList] = useState([]);
  const [all, setAll] = useState([]);
  const [newOrder, setNewOrder] = useState([]);
  const [debt, setDebt] = useState([]);
  const [updater, setUpdater] = useState(false);
  useEffect(() => {
    sendRequest("getordergeneralinfo").then(({ data }) => {
      setCardItem({
        allOrders: data.all,
        totalAmount: data.totalAmount,
        paidAmount: data.paidAmount,
        notPaidAmount: data.notPaidAmount,
      });
    });

    sendRequest2("newfilterorder").then(({ data }) => {
      setAll(data.info);
      setDebt(
        data.info.reverse().filter((order) => {
          return (
            order.total_amount - order.total_discount - order.paid_amount > 0
          );
        })
      );
    });

    sendRequest2("filter_order", {
      mtm_from: `${new Date().setMonth(new Date().getMonth() - 2)}`,
      mtm_to: `${Math.floor(new Date() / 1000)}`,
    }).then(({ data }) => {
      setNewOrder(data.info.reverse());
    });
  }, [updater]);

  return (
    <div className="allStyles">
      <Helmet>
        <meta charSet="utf-8" />
        <title>امور مالی ادمین</title>
        {/* <link rel="canonical" href="http://mysite.com/example" /> */}
      </Helmet>
      <div className="row mx-3">
        <div className="col-lg-6 col-md-6">
          <Card
            title="تعداد سفارشات"
            imgSrc={financ1}
            lightColor="#f2cc5b"
            darkColor="#bfa148"
            underline={true}
            number={addCommas(cardItem.allOrders)}
            setUpdater={setUpdater}
          ></Card>
        </div>
        <div className="col-lg-6 col-md-6">
          <Card
            title="مجموع مبلغ سفارشات"
            imgSrc={financ2}
            lightColor="#503e9d"
            darkColor="#322622"
            underline={false}
            number={addCommas(cardItem.totalAmount) + " تومان "}
            setUpdater={setUpdater}

            // number="4235000 تومان"
          ></Card>
        </div>
        <div className="col-lg-6 col-md-6">
          <Card
            title="مجموع مبلغ پرداخت شده"
            imgSrc={financ3}
            lightColor="#56a689"
            darkColor="#336252"
            underline={false}
            number={addCommas(cardItem.paidAmount) + " تومان "}
            setUpdater={setUpdater}
          ></Card>
        </div>
        <div className="col-lg-6 col-md-6">
          <Card
            title="مجموع مبلغ مانده"
            imgSrc={financ4}
            lightColor="#5f7ed9"
            darkColor="#324171"
            underline={false}
            number={addCommas(cardItem.notPaidAmount) + " تومان "}
            setUpdater={setUpdater}
          ></Card>
        </div>
      </div>

      <Financialtabs
        transactionsList={transactionsList}
        allOrder={all}
        newOrder={newOrder}
        debtOrder={debt}
        setUpdater={setUpdater}
        updater={updater}
      ></Financialtabs>
    </div>
  );
}
